import { render, staticRenderFns } from "./PersonaForm.vue?vue&type=template&id=6199180f&"
import script from "./PersonaForm.vue?vue&type=script&lang=js&"
export * from "./PersonaForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports